module.exports = __webpack_public_path__ + "img/75670.3a731796.svg";